export const GET_INSTITUTIONAL_CALENDAR_LIST = "GET_INSTITUTIONAL_LIST_CALENDAR";
export const GET_INSTITUTIONAL_CALENDAR_LIST_SUCCESS = "GET_INSTITUTIONAL_CALENDAR_LIST_SUCCESS";
export const GET_INSTITUTIONAL_CALENDAR_LIST_ERROR = "GET_INSTITUTIONAL_CALENDAR_LIST_ERROR";
export const DELETE_INSTITUTIONAL_CALENDAR = "DELETE_INSTITUTIONAL_CALENDAR";
export const DELETE_INSTITUTIONAL_CALENDAR_SUCCESS = "DELETE_INSTITUTIONAL_CALENDAR_SUCCESS";
export const DELETE_INSTITUTIONAL_CALENDAR_ERROR = "DELETE_INSTITUTIONAL_CALENDAR_ERROR";
export const ADD_INSTITUTIONAL_CALENDAR = "ADD_INSTITUTIONAL_CALENDAR";
export const ADD_INSTITUTIONAL_CALENDAR_SUCCESS = "ADD_INSTITUTIONAL_CALENDAR_SUCCESS";
export const ADD_INSTITUTIONAL_CALENDAR_ERROR = "ADD_INSTITUTIONAL_CALENDAR_ERROR";
export const RESET_INSTITUTIONAL_CALENDAR = "RESET_INSTITUTIONAL_CALENDAR";
export const SELECT_ITEMS = "SELECT_ITEMS";
export const SELECT_ITEMS_ERROR = "SELECT_ITEMS_ERROR";
export const RESET_INITIAL_FORM_VALUES = "RESET_INITIAL_FORM_VALUES";
export const SET_INITIAL_FORM_VALUES = "SET_INITIAL_FORM_VALUES";
export const ENABLE_DISABLE_INSTITUTIONAL_CALENDAR = "ENABLE_DISABLE_INSTITUTIONAL_CALENDAR";
export const ENABLE_DISABLE_INSTITUTIONAL_CALENDAR_SUCCESS = "ENABLE_DISABLE_INSTITUTIONAL_CALENDAR_SUCCESS";
export const ENABLE_DISABLE_INSTITUTIONAL_CALENDAR_ERROR = "ENABLE_DISABLE_INSTITUTIONAL_CALENDAR_ERROR";